import { useQuery } from "@apollo/client";

import { blackoutPeriodsQuery } from "./queries";

export default function useActiveBlackoutPeriods(installationId) {
  const { data, loading, error, refetch } = useQuery(blackoutPeriodsQuery, {
    variables: { installationId, includeInactive: false },
    skip: !installationId,
    fetchPolicy: "cache-and-network",
  });

  return {
    periods: data?.blackoutPeriods ?? [],
    loading,
    error,
    retry: refetch,
  };
}
